import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DynamicModuleLoader } from 'redux-dynamic-modules-react';
import getRootModule from 'RootModule';
import getSalesChallengeRateMassiveUploadModule from '../getSalesChallengeRateMassiveUploadModule';
import { layoutContext } from 'context';
import { useHistory } from 'react-router-dom';
import { Form } from 'antd';
import {
  MassiveUploadTable,
  UploadExcelButton,
  ActionButtonsExcelUpload,
} from 'common/MassiveUploads/components';
//import { triggerModalForDuplicates } from 'common/MassiveUploads/utils';
//cambiar sagas
import {
  salesChallengeMassiveUploadSetAllowUpload,
  salesChallengeMassiveUploadRequestVerify,
  salesChallengeMassiveUploadRequestUpload,
  salesChallengeMassiveUploadClearUpload,
  salesChallengeMassiveUploadClearVerify,
  salesChallengeMassiveUploadClearAllowUpload,
} from '../redux-sagas/actions';
import tableColumns from '../schemas/massiveUploadTableColumn'; //cambiar columna
const SalesChallengeMassiveUpload = (props) => {
  const {
    salesChallengeMassiveUploadSetAllowUpload: setAllowUpload,
    salesChallengeMassiveUploadRequestVerify: requestVerify,
    salesChallengeMassiveUploadRequestUpload: requestUpload,
    salesChallengeMassiveUploadClearUpload: clearUpload,
    salesChallengeMassiveUploadClearVerify: clearVerify,
    salesChallengeMassiveUploadClearAllowUpload: clearAllowUpload,
    allowUpload,
    verify,
  } = props;

  const history = useHistory();
  const [form] = Form.useForm();
  const { onChangeActiveComponent } = useContext(layoutContext);
  const [fileString, setFileString] = useState('');

  const correct = verify?.correct;
  //const entriesList = verify?.objectList;
  const entriesList = verify?.listErrors;
  //const totalDuplicatedEntries = verify?.replaced?.length;
  const allCorrectMessage = verify?.allCorrectMessage;

  useEffect(() => {
    clearAllowUpload();
    return () => {
      clearAllowUpload();
      clearUpload();
      clearVerify();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    onChangeActiveComponent('activo');
    if (correct > 0) {
      setAllowUpload(true);
    } else {
      setAllowUpload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correct]);

  function customRequest({ file }) {
    requestVerify({ file, setFileString });
  }

  function requestReplace() {
    requestUpload({ history, fileString, overwrite: false, save: true, replace: true });
  }

  function requestKeep() {
    requestUpload({ history, fileString, overwrite: false, save: false, keep: true });
  }

  function requestOverwrite() {
    requestUpload({
      history,
      fileString,
      overwrite: false,
      save: true,
      requestReplace,
      requestKeep,
      openModal: true,
    });
  }

  function onSubmit() {
    /* if (totalDuplicatedEntries > 0) {
      triggerModalForDuplicates(totalDuplicatedEntries, requestReplace, requestKeep, 'Etapa');
      return;
    } */

    requestOverwrite();
  }
  function onCancel() {
    history.push(`/sales-challenge`);
  }

  return (
    <>
      <Form form={form}>
        <UploadExcelButton customRequest={customRequest} />
        <MassiveUploadTable
          data={entriesList}
          columns={tableColumns}
          allCorrectMessage={allCorrectMessage}
        />
        <ActionButtonsExcelUpload
          onSubmit={onSubmit}
          onCancel={onCancel}
          disabled={!allowUpload}
          buttons={['cancel', 'submit']}
        />
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    allowUpload: state?.SALES_CHALLENGE_MASSIVE_UPLOAD?.allowUpload,
    verify: state?.SALES_CHALLENGE_MASSIVE_UPLOAD?.verify,
  };
};

const ConnectedUsersMassiveUpload = connect(mapStateToProps, {
  salesChallengeMassiveUploadSetAllowUpload,
  salesChallengeMassiveUploadRequestVerify,
  salesChallengeMassiveUploadRequestUpload,
  salesChallengeMassiveUploadClearUpload,
  salesChallengeMassiveUploadClearVerify,
  salesChallengeMassiveUploadClearAllowUpload,
})(SalesChallengeMassiveUpload);

const UsersMassiveUploadWithModules = () => {
  return (
    <DynamicModuleLoader modules={[getRootModule(), getSalesChallengeRateMassiveUploadModule()]}>
      <ConnectedUsersMassiveUpload />
    </DynamicModuleLoader>
  );
};
export default UsersMassiveUploadWithModules;
